import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Stipend from './stipend'
import { formatWithCommas } from "../../helpers/common";


const Stipends = ({ getStipendsDetails, contract }) => {
    const navigate = useNavigate();
    const [stipends, setStipends] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [selectedStipends, setSelectedStipends] = useState([]);
    useEffect(() => {

        getStipends();

    }, []);

  
    const getStipends = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-stipends", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setStipends(response?.data?.stipends);
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }

   

    const handleCheckboxChange = (id) => {
       
       // console.log(e.target.checked);
        if (selectedStipends.indexOf(id) === -1) {
             setSelectedStipends([...selectedStipends,id]);
        } else {
          setSelectedStipends(selectedStipends.filter((s) => s != id));
        }
      };


    const removeStipends = async (selected=0) => {

        let params = {};
        if(selected == 1){
            params = {
                stipend_ids : selectedStipends,
            }
        }
        axios.post(process.env.REACT_APP_API_URL + "/remove-stipends", params ,{
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                
                if (response?.data?.status) {
                    
                    setEditMode(false);
                    getStipends();
                    setSelectedStipends([]);

                }



            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }
    return (


        <div className="card" >

            <div className="card-title" >

                <div className="stipend-label">
                    <span className="box-title color-white fs-18 fs-helvetica">Stipends</span>
                    <div className="tooltip">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="info-icon"
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="#ccc"
                        >
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
               10-4.48 10-10S17.52 2 12 2zm0 4a1.25 1.25 0 110 2.5A1.25 1.25 0 0112 6zm1 12h-2v-6h2v6z"/>
                        </svg>
                        <span className="tooltiptext">Enter Weekly Stipend.</span>
                    </div>
                </div>


                {stipends && stipends.length > 0  &&
                <>
                {editMode ?
                    <button className="btn btn-link fs-12" onClick={() => { setEditMode(false); setSelectedStipends([]); }}  >Cancel</button>
                    :
                    <button className="btn btn-link fs-12" onClick={() => setEditMode(true)}  >Edit</button>
                }
                </>
                }
            </div>

            <div className="card-content" >

                {stipends && stipends.map((s, index) => {
                    return (
                        <div className={"list-layout "+ ((selectedStipends.indexOf(s.stipend_id) !== -1) && "selected")}
                        onClick = {() => editMode && handleCheckboxChange(s.stipend_id)}
                        >
                            {editMode &&
                                <input name="stipends[]" type="checkbox" className="chk chk-primary" 
                                value={s.stipend_id}
                                checked={(selectedStipends.indexOf(s.stipend_id) !== -1)}
                               
                                 />
                            }
                            <label className="color-light fs-12  list-text">${formatWithCommas(s.stipend_amount)}</label>
                            <button className="btn btn-sm btn-secondary list-button ">{s.tag_title}</button>
                        </div>
                    )
                }
                )}

                {contract && 
                    <div className={"list-layout "+ (selectedStipends?.length > 0 ? "justify-content-space-between":"justify-content-end" )  } >
                        <Stipend stipends={stipends} getStipendsDetails={getStipendsDetails} updateStipendList={getStipends} selectedStipends={selectedStipends} editMode={editMode} removeStipends={removeStipends} />
                    </div>
                }



            </div>

        </div>






    );
};

export default Stipends;